import React from "react";

/**
 * Sets `document.title` to "<title> · Orbit Admin" while the calling page is
 * mounted, restoring the previous title on unmount. Gives each back-office
 * route a distinct browser-tab label (Companies vs Audit log vs Settings…).
 */
export function usePageTitle(title: string): void {
  React.useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · Orbit Admin` : "Orbit Admin";
    return () => {
      document.title = previous;
    };
  }, [title]);
}
